export default async function downloadFile(url: string, filenameHint?: string): Promise<void> {
  const targetUrl = new URL(url, window.location.origin);
  const sameOrigin = targetUrl.origin === window.location.origin;

  let headers: HeadersInit | undefined;
  if (sameOrigin) {
    const token = window.localStorage.getItem('policyora_token');
    if (token) {
      headers = { Authorization: `Bearer ${token}` };
    }
  }

  const response = await fetch(targetUrl.toString(), {
    method: 'GET',
    headers,
    credentials: sameOrigin ? 'include' : 'omit',
  });

  if (!response.ok) {
    const message = `Failed to download file${response.status ? ` (status ${response.status})` : ''}`;
    throw new Error(message);
  }
  const blob = await response.blob();
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.download = filenameHint || 'download';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(downloadUrl);
}
